//
//
//
//
//
//
//
//

export default {
  name: "ProductCardLoading"
}
